import { useQuery } from '@apollo/client';

import type { GetProfileAvatarQuery } from 'src/types/graphql';

import { getProfileAvatar } from './avatar.graphql';

export const useGetProfileAvatar = () => {
  const { data } = useQuery<GetProfileAvatarQuery>(getProfileAvatar);

  const profileAvatar = data?.viewer?.profileAvatar;

  return {
    profileAvatar,
  };
};
